import React from 'react'
import { shadow } from '@mobi/component-library/Foundations'

const enum LocalConstants {
  ScrollThresholdPx = 3,
}

export const useShadowOnTopScroll = () => {
  const stickyEl1Ref = React.useRef<HTMLDivElement>(null)
  const stickyEl2Ref = React.useRef<HTMLDivElement>(null)

  const firstElHeightPx = React.useRef<number>(0)

  // ========================================
  // If 2 Elements - Set first element height
  // ========================================

  React.useEffect(() => {
    if (!window.ResizeObserver || !stickyEl1Ref.current || !stickyEl2Ref.current) return
    const el1 = stickyEl1Ref.current
    const el2 = stickyEl2Ref.current
    const handleUpdate = () => {
      const offsetHeight = el1.offsetHeight
      el2.style.top = offsetHeight + 'px'
      firstElHeightPx.current = offsetHeight
    }
    handleUpdate()
    const observer = new ResizeObserver(handleUpdate)
    observer.observe(document.body)
    return () => observer.disconnect()
  }, [])

  // ==============================
  // Set sticky styles for elements
  // ==============================

  React.useEffect(() => {
    if (!stickyEl1Ref.current) return
    stickyEl1Ref.current.style.position = 'sticky'
    stickyEl1Ref.current.style.top = '0px'
    stickyEl1Ref.current.style.zIndex = '2'
  }, [])

  React.useEffect(() => {
    if (!stickyEl2Ref.current) return
    stickyEl2Ref.current.style.position = 'sticky'
    stickyEl2Ref.current.style.transition = 'box-shadow 0.125s ease'
    stickyEl2Ref.current.style.zIndex = '1'
  }, [])

  // ========================
  // Handle scroll add shadow
  // ========================

  React.useEffect(() => {
    const el1 = stickyEl1Ref.current
    if (!el1) return

    const el2 = stickyEl2Ref.current
    const elementToApplyShadow = el2 || el1

    const handleScroll = () => {
      const value =
        elementToApplyShadow.getBoundingClientRect().top <
        firstElHeightPx.current + LocalConstants.ScrollThresholdPx
          ? shadow.md
          : 'none'

      elementToApplyShadow.style.boxShadow = value
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return { stickyEl1Ref, stickyEl2Ref }
}
